import { z } from 'zod';
import { aboutUsContentSchema } from './content/about-us';
import { accidentTypeContentSchema } from './content/accident-type';
import { caseResultContentSchema } from './content/case-results';
import { contentBase } from './content/content';
import { founderContentSchema } from './content/founder';
import { footerSchema } from './content/footer';
import { injuryContentSchema } from './content/injury';
import { injuryTypeContentSchema } from './content/injury-type';
import { navbarContentSchema } from './content/navbar';
import { practiceAreasContentSchema } from './content/practice-areas';
import { processStepContentSchema } from './content/process-steps';
import { reasonToChooseUsContentSchema } from './content/reasons-to-choose-us';
import { recoveryExpertiseContentSchema } from './content/recovery-expertise';
import { testimonialContentSchema } from './content/testimonials';
import { thingsToKnowAboutContentSchema } from './content/things-to-know-about';
import { waysToHelpContentSchema } from './content/ways-to-help';

export * from './content/about-us';
export * from './content/accident-type';
export * from './content/case-results';
export * from './content/founder';
export * from './content/footer';
export * from './content/injury-type';
export * from './content/injury';
export * from './content/navbar';
export * from './content/practice-areas';
export * from './content/process-steps';
export * from './content/reasons-to-choose-us';
export * from './content/recovery-expertise';
export * from './content/testimonials';
export * from './content/things-to-know-about';
export * from './content/ways-to-help';

export const contentSchema = contentBase.extend({
  content: z.union([
    aboutUsContentSchema,
    accidentTypeContentSchema,
    caseResultContentSchema,
    founderContentSchema,
    footerSchema,
    injuryContentSchema,
    injuryTypeContentSchema,
    navbarContentSchema,
    practiceAreasContentSchema,
    processStepContentSchema,
    reasonToChooseUsContentSchema,
    recoveryExpertiseContentSchema,
    testimonialContentSchema,
    thingsToKnowAboutContentSchema,
    waysToHelpContentSchema,
  ]),
});

export type ContentInput = z.infer<typeof contentSchema>;
